import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPurchaseOrderDeliveryDisbursement implements BaseEnumType {
  private static allValues: EnumPurchaseOrderDeliveryDisbursement[] = []; // make sure this is top-most
  
  public static none = new EnumPurchaseOrderDeliveryDisbursement(0, "None", "enum_purchase_order_delivery_disbursement_none");
  public static manual = new EnumPurchaseOrderDeliveryDisbursement(1, "Manual", "enum_purchase_order_delivery_disbursement_manual");
  public static byValue = new EnumPurchaseOrderDeliveryDisbursement(2, "ByValue", "enum_purchase_order_delivery_disbursement_by_value");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPurchaseOrderDeliveryDisbursement.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumPurchaseOrderDeliveryDisbursement.none; }
  public isManual() { return this === EnumPurchaseOrderDeliveryDisbursement.manual; }
  public isByValue() { return this === EnumPurchaseOrderDeliveryDisbursement.byValue; }

  public static getValues(): readonly EnumPurchaseOrderDeliveryDisbursement[] {
    return EnumPurchaseOrderDeliveryDisbursement.allValues;
  }

  public static getValuesExcept0(): readonly EnumPurchaseOrderDeliveryDisbursement[] {
    return EnumPurchaseOrderDeliveryDisbursement.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPurchaseOrderDeliveryDisbursement {
    const found = EnumPurchaseOrderDeliveryDisbursement.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPurchaseOrderDeliveryDisbursement - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPurchaseOrderDeliveryDisbursement): EnumPurchaseOrderDeliveryDisbursement {
    const found = name ? EnumPurchaseOrderDeliveryDisbursement.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPurchaseOrderDeliveryDisbursement - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPurchaseOrderDeliveryDisbursement>): boolean {
    return this.key === other?.key;
  }
}